import React, { useState, useEffect } from "react";
import "./Contact.css";
import Navbar from './Navbar';
import './services/Common.css';
import { MapPin, Phone, Mail } from 'lucide-react';
import Footer from "../Footer";
import { ChevronLeft, ChevronRight } from 'lucide-react'; // Import icons for slider buttons
import slider1 from '../../assets/slider1.png';
import slider2 from '../../assets/slider2.png';
import slider3 from '../../assets/slider3.png';
import slider4 from '../../assets/slider4.png';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: "",
        designation: "",
        organization: "",
        email: "",
        contactNo: "",
        message: "",
    });

    // Slider state and logic
    const [currentSlide, setCurrentSlide] = useState(0);

    const images = [
        {
            src: slider1,
            title: 'Confusion to Clarity',
            description: 'Uniaariv empowers you to discover yourself, align your uniqueness, strengths, etc. with your natural inclination, unlock your fullest potential, and step into a future that’s truly yours (the field/sector) to do, be, succeed, and live an accomplished life.',
        },
        {
            src: slider2,
            title: 'Limited Perspective to Deep Insights',
            description: 'Empower CHRO to make unbiased informed decisions, cultivate a high-performance culture, future-proof the organization by early identification, nurturing potential leaders, and avoiding potential ethical and moral challenges.',
        },
        {
            src: slider3,
            title: 'Complexity to Simplicity',
            description: '',
        },
        {
            src: slider4,
            title: '',
            description: 'All our training programs are designed by blending modern science with universal science, the laws of nature, the depth and dimensions of life, existential realities, and real-life personal and professional experiences. Our endeavor is not just to transfer knowledge (information) but also to help you understand it from different perspectives and experience it firsthand.',
        },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [currentSlide]);

    const nextSlide = () => {
        setCurrentSlide((prevSlide) =>
            prevSlide === images.length - 1 ? 0 : prevSlide + 1
        );
    };

    const prevSlide = () => {
        setCurrentSlide((prevSlide) =>
            prevSlide === 0 ? images.length - 1 : prevSlide - 1
        );
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, designation, organization, email, contactNo, message } = formData;

        try {
            const response = await fetch("https://trzcibvdzplyilvleolv.supabase.co/functions/v1/send-mail", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ name, designation, organization, email, contactNo, message }),
            });

            if (response.ok) {
                alert("Message sent successfully!");
                setFormData({ name: "", designation: "", organization: "", email: "", contactNo: "", message: "" });
            } else {
                alert("Failed to send the message. Please try again.");
            }
        } catch (error) {
            alert("An error occurred. Please try again later.");
        }
    };

    return (
        <div className="page">
            <Navbar />
            <div className="hero-section">
                {/* Replace the static image with the slider */}
                <div className="hero-slider">
                    <button className="slider-btn prev" onClick={prevSlide}>
                        <ChevronLeft size={24} />
                    </button>
                    <div className="slider-container">
                        {images.map((image, index) => (
                            <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
                                <img src={image.src} alt={`Slide ${index + 1}`} className="slide-image" />
                                <div className="slide-content">
                                    <p>{image.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className="slider-btn next" onClick={nextSlide}>
                        <ChevronRight size={24} />
                    </button>
                </div>
                <h1>Contact</h1>
            </div>

            <div className="contact-container">
                <div className="contact-left">
                    <h2>OUR OFFICE</h2>
                    <div className="contact-info-item">
                        <MapPin size={18} />
                        <div>
                            <p>Uniaariv Consultancy Services</p>
                            <p>204, New Vrindavan, Church Road,</p>
                            <p>Vile Parle (West), Mumbai 400 056.</p>
                        </div>
                    </div>
                    <div className="contact-info-item">
                        <Phone size={18} />
                        <span>+919619 123234, 99205 41001</span>
                    </div>
                    <div className="contact-info-item">
                        <Mail size={18} />
                        <span>contact@uniaariv.com</span>
                    </div>
                </div>
                <div className="contact-right">
                    <form onSubmit={handleSubmit}>
                        <div className="form-row">
                            <input
                                type="text"
                                name="name"
                                placeholder="Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="designation"
                                placeholder="Designation"
                                value={formData.designation}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="organization"
                                placeholder="Organization"
                                value={formData.organization}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="contactNo"
                                placeholder="Contact No."
                                value={formData.contactNo}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <textarea
                            name="message"
                            placeholder="Message"
                            value={formData.message}
                            onChange={handleChange}
                            required
                        />
                        <button type="submit">Send</button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Contact;